/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import OptionSelect from '../../OptionSelect';
import { useQuestionnaireData } from '../context';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';

const useStyles = makeStyles((theme) => ({
  optionSelectRoot: {
    marginTop: 30,
    justifyContent: 'space-between',
    '& .MuiGrid-grid-sm-6': {
      flexBasis: '49.5%',
      maxWidth: '49.5%',
      marginBottom: 4,
      [theme.breakpoints.down('sm')]: {
        flexBasis: '100%',
        maxWidth: '100%',
      },
    },
    '& button': {
      minHeight: '90%',
    },
  },
  optionSelectRootFixedWidth: {
    maxWidth: ({ provider }) => (provider ? 'unset' : 450),
    marginTop: 30,
    justifyContent: 'space-between',
    '& button': {
      minHeight: '90%',
    },
  },
}));

export const MultipleOptionSelect = ({ question, value, onChange }) => {
  const {
    id: questionId, title, subtitle, options,
  } = question;
  const { form, provider } = useSelector((state) => ({
    form: state.form,
    provider: state?.appConfiguration?.providerSpecific?.code,
  }));
  const { embedded } = useQuestionnaireData();
  const classes = useStyles({ provider });

  const handleOptionSelectChange = (option) => {
    const isExclusive = option[option.length - 1]?.exclusive;
    const exclusiveOption = option?.find((val) => val.exclusive);
    if (isExclusive) {
      onChange([exclusiveOption]);
    }
    if (exclusiveOption && option.length === 1) {
      onChange([exclusiveOption]);
    }
    if (exclusiveOption && option.length > 1 && !isExclusive) {
      onChange(option.filter((item) => !item.exclusive));
    }
    if (option.length > 1 && !isExclusive) {
      onChange(option.filter((item) => !item.exclusive));
    }
    if (!exclusiveOption) {
      onChange(option);
    }
  };

  const splitIntoColumns = !embedded && options.length >= 10;

  return (
    <Grid key={questionId}>
      <QuestionTitle label={title} />

      {subtitle && <QuestionSubTitle label={subtitle} />}

      <OptionSelect
        options={options}
        values={value ?? []}
        form={form}
        isMultipleSelection
        splitIntoColumns={splitIntoColumns}
        onChange={handleOptionSelectChange}
        rootClassName={`${!splitIntoColumns ? classes.optionSelectRootFixedWidth : classes.optionSelectRoot}`}
        small={embedded}
      />
    </Grid>
  );
};

MultipleOptionSelect.propTypes = {
  /**
   * Question object with title, subtitles, etc
   */
  question: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
